class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    
    // 跟新选择的产品图
    const featuredMediaId = document.querySelector('[data-selected-featured_media]')?.dataset.selectedFeatured_media;
    this.fixSlide(featuredMediaId);
    this.fixSlideClick()
  }
  
  /**
   * 更新变体
   */
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    this.removeErrorMessage();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }
  
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }
  
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  
  /**
   * 跟新变体图片
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    this.fixSlide(this.currentVariant.featured_media.id);
    // const parent = newMedia.parentElement;
    // parent.prepend(newMedia);
    // window.setTimeout(() => { parent.scroll(0, 0) });
  }
  
  /**
   * 修复滚动提示
   */
  fixSlide(id) {
    const slideshowElement = document.querySelector(`#shopify-section-${this.dataset.section} [uk-slideshow]`)
    const sliderElement = document.querySelector(`#shopify-section-${this.dataset.section} [uk-slider]`)
    const oLis = UIkit.util.queryAll(`#shopify-section-${this.dataset.section} [uk-slider] img`);
    const selectSlide = document.querySelector(`[data-thumbnail-id="${id}"] img`);
    const newMedia = document.querySelector(`[data-media-id="${this.dataset.section}-${id}"]`);
    const imageIndex = newMedia.dataset.imageIndex;
    
    if (!newMedia) return;
    UIkit.util.removeClass(oLis, 'tm-active');
    selectSlide.classList.add('tm-active');
    
    UIkit.slideshow(slideshowElement).show(imageIndex);
    UIkit.slider(sliderElement).show(imageIndex);
  }
  
  fixSlideClick() {
    const sliderElement = document.querySelector(`#shopify-section-${this.dataset.section} [uk-slider]`)
    const oLis = UIkit.util.queryAll(`#shopify-section-${this.dataset.section} [uk-slider] img`);
    UIkit.util.on(oLis, 'click', (event) => {
      const index = event.target.closest('li').getAttribute('uk-slideshow-item');
      const imageIndex = event.target.closest('li').dataset.thumbnailId;
      UIkit.slider(sliderElement).show(index);
      this.fixSlide(imageIndex);
    })
    
  }
  
  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  
  /**
   * 更新快速结账匹配产品ID
   */
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }
  
  // updatePickupAvailability() {
  //   const pickUpAvailability = document.querySelector('pickup-availability');
  //   if (!pickUpAvailability) return;
  //
  //   if (this.currentVariant?.available) {
  //     pickUpAvailability.fetchAvailability(this.currentVariant.id);
  //   } else {
  //     pickUpAvailability.removeAttribute('available');
  //     pickUpAvailability.innerHTML = '';
  //   }
  // }
  
  /**
   * 更新产品状态
   * @returns {Promise<void>}
   */
  async renderProductInfo() {
    const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
    const id = `price-${this.dataset.section}`;
    const destination = document.getElementById(id);
    this.source = await fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        return html.getElementById(id);
      });
    if (this.source && destination) destination.innerHTML = this.source.innerHTML;
    document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
  }
  
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtonInnerHtml = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]').querySelector('span');
    
    if (!addButton) return;
    
    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonInnerHtml.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonInnerHtml.textContent = window.variantStrings.addToCart;
    }
    
    if (!modifyClass) return;
  }
  
  
  /**
   * 变体不存在时禁用按钮和价格
   */
  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtonInnerHtml = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]').querySelector('span');
    if (!addButton) return;
    addButtonInnerHtml.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('uk-hidden');
  }
  
  /**
   * 获取产品json并缓存
   * @returns {*}
   */
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  
  /**
   * 购物车超过库存数量时提示错误信息
   */
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }
  
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
